import type { User } from '@sentry/react';
import * as Sentry from '@sentry/react';

import { ENVIRONMENT, PACKAGE_VERSION, SENTRY_DSN } from '@constants';

export const sentry = {
  init: ({ debug = false } = {}) => {
    if (SENTRY_DSN) {
      Sentry.init({
        dsn: SENTRY_DSN,
        release: `apolo@${PACKAGE_VERSION}`,
        environment: ENVIRONMENT,

        /**
         * Set tracesSampleRate to 1.0 to capture 100%
         * of transactions for performance monitoring.
         */
        tracesSampleRate: 1.0,

        /**
         * If debug is enabled SDK will attempt to print out useful debugging
         * information if something goes wrong with sending the event.
         */
        debug,
      });
    }
  },

  setUser: ({ username, email }: User) => {
    Sentry.setUser({ username, email });
  },
};
